import { PropsWithChildren } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "notistack";
import { IntercomProvider } from "react-use-intercom";
import theme from "@/theme";
import { AuthProvider } from "@/features/auth";
import AxiosInterceptor from "@/lib/axios-interceptor";
import queryClient from "@/lib/query-client";

const INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

const AppProviders = ({ children }: PropsWithChildren) => (
  <SnackbarProvider
    anchorOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    preventDuplicate
  >
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <IntercomProvider appId={INTERCOM_APP_ID}>
          <AxiosInterceptor>
            <ThemeProvider theme={theme}>{children}</ThemeProvider>
          </AxiosInterceptor>
        </IntercomProvider>
      </AuthProvider>
    </QueryClientProvider>
  </SnackbarProvider>
);

export default AppProviders;
